import AppSettings from "@profilog/front/app/AppSettings";

export function getLangsFromEnv() {
    return {
        projectLang: AppSettings.projectLang,
        forcedLang: AppSettings.forcedLang,
    };
}
